// Copyright (c) 2019 Deere & Company

export default Object.freeze( {
    // ADD_SUCCESS_ALERT_MESSAGE: 'ADD_SUCCESS_ALERT_MESSAGE',
    // ADD_ERROR_ALERT_MESSAGE: 'ADD_ERROR_ALERT_MESSAGE',
    // DECREASE_APPLICATION_BUSY_COUNTER: 'DECREASE_APPLICATION_BUSY_COUNTER',
    // DISCARD_ALERT_MESSAGES: 'DISCARD_ALERT_MESSAGES',
    // FETCH_FOOTER_LINKS: 'FETCH_FOOTER_LINKS',
    // INCREASE_APPLICATION_BUSY_COUNTER: 'INCREASE_APPLICATION_BUSY_COUNTER',
    LOAD_FACTORIES: 'LOAD_FACTORIES',
    UPDATE_FACTORY_CODE: 'UPDATE_FACTORY_CODE',
} );
